import React from 'react';
import './privacy.scss'

export default function Privacy() {
  return (
    <div className='privacy'>
      <h2>mNeme Privacy Policy</h2>
      <p>Last updated January 13, 2020</p>

      <h3>Introduction</h3>
      <p>
        mNeme (“we” or “us” or “our”) respects the privacy of our users (“user”
        or “you”). This Privacy Policy explains how we collect, use, disclose,
        and safeguard your information when you visit our website
        [mneme-staging.netlify.com], including any other media form, media
        channel, mobile website, or mobile application related or connected
        thereto (collectively, the “Site”). Please read this privacy policy
        carefully. If you do not agree with the terms of this privacy policy,
        please do not access the site. We reserve the right to make changes to
        this Privacy Policy at any time and for any reason. We will alert you
        about any changes by updating the “Last Updated” date of this Privacy
        Policy. Any changes or modifications will be effective immediately upon
        posting the updated Privacy Policy on the Site, and you waive the right
        to receive specific notice of each such change or modification. You are
        encouraged to periodically review this Privacy Policy to stay informed
        of updates. You will be deemed to have been made aware of, will be
        subject to, and will be deemed to have accepted the changes in any
        revised Privacy Policy by your continued use of the Site after the date
        such revised Privacy Policy is posted. This Privacy Policy was generated
        by Termly’s Privacy Policy Generator.
      </p>

      <h3>Collection of Your information</h3>
      <p>
        We may collect information about you in a variety of ways. The
        information we may collect on the Site includes:
      </p>

      <h4>Personal Data</h4>
      <p>
        Personally identifiable information, such as your name, shipping
        address, email address, and telephone number, and demographic
        information, such as your age, gender, hometown, and interests, that you
        voluntarily give to us [when you register with the Site or] when you
        choose to participate in various activities related to the Site, such as
        online chat and message boards. You are under no obligation to provide
        us with personal information of any kind, however your refusal to do so
        may prevent you from using certain features of the Site .
      </p>

      <h4>Derivative Data</h4>
      <p>
        Information our servers automatically collect when you access the Site,
        such as your IP address, your browser type, your operating system, your
        access times, and the pages you have viewed directly before and after
        accessing the Site. [If you are using our mobile application, this
        information may also include your device name and type, your operating
        system, your phone number, your country, your likes and replies to a
        post, and other interactions with the application and other users via
        server log files, as well as any other information you choose to
        provide.]
      </p>

      <h4>Facebook Permissions</h4>
      <p>
        The Site may by default access your Facebook basic account information,
        including your name, email, gender, birthday, current city, and profile
        picture URL, as well as other information that you choose to make
        public. We may also request access to other permissions related to your
        account, such as friends, checkins, and likes, and you may choose to
        grant or deny us access to each individual permission. For more
        information regarding Facebook permissions, refer to the Facebook
        Permissions Reference page.
      </p>

      <h4>Mobile Device Data</h4>
      <p>
        Device information, such as your mobile device ID, model, and
        manufacturer, and information about the location of your device, if you
        access the Site from a mobile device.
      </p>

      <h4>Third-Party Data</h4>
      <p>
        Information from third parties, such as personal information or network
        friends, if you connect your account to the third party and grant the
        Site permission to access this information.
      </p>

      <h4>Data From Contests, Giveaways, and Surveys</h4>
      <p>
        Personal and other information you may provide when entering contests or
        giveaways and/or responding to surveys.
      </p>

      <h3>Use of Your Information</h3>
      <p>
        Having accurate information about you permits us to provide you with a
        smooth, efficient, and customized experience. Specifically, we may use
        information collected about you via the Site to:
      </p>

      <ul>
        <li>Administer sweepstakes, promotions, and contests.</li>
        <li>Assist law enforcement and respond to subpoena.</li>
        <li>
          Compile anonymous statistical data and analysis for use internally or
          with third parties.
        </li>
        <li>Create and manage your account.</li>
        <li>Email you regarding your account or order.</li>
        <li>
          Generate a personal profile about you to make future visits to the
          Site more personalized.
        </li>
        <li>Increase the efficiency and operation of the Site.</li>
        <li>
          Monitor and analyze usage and trends to improve your experience with
          the Site.
        </li>
        <li>Perform other business activities as needed.</li>
        <li>Request feedback and contact you about your use of the Site.</li>
        <li>Resolve disputes and troubleshoot problems.</li>
        <li>Respond to product and customer service requests.</li>
        <li>Solicit support for the Site.</li>
      </ul>

      <h3>Disclosure of Your Information</h3>
      <p>
        We may share information we have collected about you in certain
        situations. Your information may be disclosed as follows:
      </p>
      <h4>By Law or to Protect Rights</h4>
      <p>
        If we believe the release of information about you is necessary to
        respond to legal process, to investigate or remedy potential violations
        of our policies, or to protect the rights, property, and safety of
        others, we may share your information as permitted or required by any
        applicable law, rule, or regulation. This includes exchanging
        information with other entities for fraud protection and credit risk
        reduction.
      </p>

      <h4>Third-Party Service Providers</h4>
      <p>
        We may share your information with third parties that perform services
        for us or on our behalf, including payment processing, data analysis,
        email delivery, hosting services, customer service, and marketing
        assistance.
      </p>

      <h4>Interactions with Other Users</h4>
      <p>
        If you interact with other users of the Site, those users may see your
        name, profile photo, and descriptions of your activity, including
        sending invitations to other users, chatting with other users, liking
        posts, following blogs.
      </p>

      <h3>Tracking Technologies</h3>

      <h4>Cookies and Web Beacons</h4>
      <p>
        We may use cookies, web beacons, tracking pixels, and other tracking
        technologies on the Site to help customize the Site and improve your
        experience. When you access the Site, your personal information is not
        collected through the use of tracking technology. Most browsers are set
        to accept cookies by default. You can remove or reject cookies, but be
        aware that such action could affect the availability and functionality
        of the Site. You may not decline web beacons. However, they can be
        rendered ineffective by declining all cookies or by modifying your web
        browser’s settings to notify you each time a cookie is tendered,
        permitting you to accept or decline cookies on an individual basis. [We
        may use cookies, web beacons, tracking pixels, and other tracking
        technologies on the Site to help customize the Site and improve your
        experience. For more information on how we use cookies, please refer to
        our Cookie Policy posted on the Site, which is incorporated into this
        Privacy Policy. By using the Site, you agree to be bound by our Cookie
        Policy.]
      </p>

      <h4>Website Analytics</h4>
      <p>
        We may also partner with selected third-party vendors[, such as [Adobe
        Analytics,] [Clicktale,] [Clicky,] [Cloudfare,] [Crazy Egg,] [Flurry
        Analytics,] [Google Analytics,] [Heap Analytics,] [Inspectlet,]
        [Kissmetrics,] [Mixpanel,] [Piwik,] and others], to allow tracking
        technologies and remarketing services on the Site [and our mobile
        application] through the use of first party cookies and third-party
        cookies, to, among other things, analyze and track users’ use of the
        Site [and our mobile application], determine the popularity of certain
        content and better understand online activity. By accessing the Site
        [,our mobile application,], you consent to the collection and use of
        your information by these third-party vendors. You are encouraged to
        review their privacy policy and contact them directly for responses to
        your questions. We do not transfer personal information to these
        third-party vendors. However, if you do not want any information to be
        collected and used by tracking technologies, you can visit the
        third-party vendor or the Network Advertising Initiative Opt-Out Tool or
        Digital Advertising Alliance Opt-Out Tool. You should be aware that
        getting a new computer, installing a new browser, upgrading an existing
        browser, or erasing or otherwise altering your browser’s cookies files
        may also clear certain opt-out cookies, plug-ins, or settings.
      </p>

      <h3>Security of Your Information</h3>
      <p>
        We use administrative, technical, and physical security measures to help
        protect your personal information. While we have taken reasonable steps
        to secure the personal information you provide to us, please be aware
        that despite our efforts, no security measures are perfect or
        impenetrable, and no method of data transmission can be guaranteed
        against any interception or other type of misuse. Any information
        disclosed online is vulnerable to interception and misuse by
        unauthorized parties. Therefore, we cannot guarantee complete security
        if you provide personal information.
      </p>

      <h3>Policy for Children</h3>
      <p>
        We do not knowingly solicit information from or market to children under
        the age of 13. If you become aware of any data we have collected from
        children under age 13, please contact us using the contact information
        provided below.
      </p>

      <h3>Controls for Do-Not-Track Features</h3>
      <p>
        Most web browsers and some mobile operating systems include a
        Do-Not-Track (“DNT”) feature or setting you can activate to signal your
        privacy preference not to have data about your online browsing
        activities monitored and collected. No uniform technology standard for
        recognizing and implementing DNT signals has been finalized. As such, we
        do not currently respond to DNT browser signals or any other mechanism
        that automatically communicates your choice not to be tracked online. If
        a standard for online tracking is adopted that we must follow in the
        future, we will inform you about that practice in a revised version of
        this Privacy Policy. Most web browsers and some mobile operating systems
        include a Do-Not-Track (“DNT”) feature or setting you can activate to
        signal your privacy preference not to have data about your online
        browsing activities monitored and collected. If you set the DNT signal
        on your browser, we will respond to such DNT browser signals.
      </p>

      <h3>Options Regarding Your Information</h3>
      <h4>Account Information</h4>
      <p>
        You may at any time review or change the information in your account or
        terminate your account by:
      </p>
      <ul>
        <li>Logging into your account settings and updating your account</li>
        <li>Contacting us using the contact information provided below</li>
      </ul>
      <p>
        Upon your request to terminate your account, we will deactivate or
        delete your account and information from our active databases. However,
        some information may be retained in our files to prevent fraud,
        troubleshoot problems, assist with any investigations, enforce our Terms
        of Use and/or comply with legal requirements.
      </p>

      <h3>California Privacy Rights</h3>
      <p>
        California Civil Code Section 1798.83, also known as the “Shine The
        Light” law, permits our users who are California residents to request
        and obtain from us, once a year and free of charge, information about
        categories of personal information (if any) we disclosed to third
        parties for direct marketing purposes and the names and addresses of all
        third parties with which we shared personal information in the
        immediately preceding calendar year. If you are a California resident
        and would like to make such a request, please submit your request in
        writing to us using the contact information provided below. If you are
        under 18 years of age, reside in California, and have a registered
        account with the Site, you have the right to request removal of unwanted
        data that you publicly post on the Site. To request removal of such
        data, please contact us using the contact information provided below,
        and include the email address associated with your account and a
        statement that you reside in California. We will make sure the data is
        not publicly displayed on the Site, but please be aware that the data
        may not be completely or comprehensively removed from our systems.
      </p>

      <h3>Contact Us</h3>
      <p>
        If you have questions or comments about this Privacy Policy, please
        contact us at:
      </p>
      <p>lambdaflashcards@gmail.com</p>
    </div>
  );
}
